import { authConstants, alertConstants} from '../_constants'
import { auditConstants} from '../_constants/audit.constants'

import { auditService } from '../_services/audit.service'
import { alertActions } from '.'

export const auditActions = {

  getAll,
  getCurrentUserDetail,
  getCurrentToken,
  getAuditsByPage,
  clearAllMessages,
  getAuditById,

}

function getAll() {
  return dispatch => {
    dispatch(request())
    auditService.getAll()
      .then(
        audits => dispatch(success(audits)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() { return { type: auditConstants.GETALL_REQUEST } }
  function success(audits) { return { type: auditConstants.GETALL_SUCCESS, audits } }
  function failure(error) { return { type: auditConstants.GETALL_FAILURE, error } }
}

function getCurrentUserDetail(){
  return {token:localStorage.getItem(authConstants.TOKEN_KEY), userName:localStorage.getItem(authConstants.USER_NAME)}
}

function getCurrentToken(){
  return localStorage.getItem(authConstants.TOKEN_KEY)
}


function getAuditsByPage(start,pageSize,search) {
  return dispatch => {
    dispatch(request())
    auditService.getAuditsByPage(start,pageSize,search)
      .then(
        audits => {
          if(audits.data)
            dispatch(success(audits))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(audits) { return { type: auditConstants.GETALL_PAGE_REQUEST, audits } }
  function success(audits) { return { type: auditConstants.GETALL_PAGE_SUCCESS, audits } }
  function failure(error) { return { type: auditConstants.GETALL_PAGE_FAILURE, error } }
}

function clearAllMessages()
{
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}
function getAuditById(id) {
  return dispatch => {
    dispatch(request())

    auditService.getAuditById(id)
      .then(
        user => {
          console.log(user)
          dispatch(success(user))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: auditConstants.GETBYID_REQUEST, user } }
  function success(user) { return { type: auditConstants.GETBYID_SUCCESS, user } }
  function failure(error) { return { type: auditConstants.GETBYID_FAILURE, error } }
}

